import React from "react";

export default () => <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.86961 0.490156L0.0996095 2.27016L9.99961 12.1602L19.8996 2.26016L18.1296 0.490156L9.99961 8.62016L1.86961 0.490156Z" fill="#595959"/>
</svg>
